import React, { useState, useEffect } from 'react';
import { PhoneOutlined} from '@mui/icons-material/';
import { Grid } from '@material-ui/core';

import { Form} from 'antd';
import SobreClube from './SobreClube';
import Button2 from '@components/Shared/Buttons/Button';
import './styles.css';
import ButtonComponent from '@components/Shared/Buttons/Button';

import { TitlePage, SubTitle, InterTitle} from '@styles/styles.global';

//import '@styles/AntStyles.css';


const ClubePaiEterno: React.FC = () => {

  const [openModalSobreClube, setOpenModalSobreClube] =
  useState(false);

  return (
    <>
      <Grid container>
      {/* MODAL */}
    {openModalSobreClube && (
      <SobreClube
        onClose={() => setOpenModalSobreClube(false)}
      />
    )}
        <div
          style={{
            position: 'relative',
            width: '100%',
          }}
        >


          {/* ================== CABEÇALHO ==================== */}

          <Grid container>
  <Grid item lg={12} sm={12} xs={12}>
    <div
      style={{
        position: 'relative',
        width: '100%',
        overflow: 'hidden',
      }}
    >

      {/* Imagem de fundo */}
      <img
        src={'https://crm-clickdobem.s3.sa-east-1.amazonaws.com/AFIPE/logo_clube.png'}
        alt="Cabeçalho"
        style={{
          width: '100%',
          height: 'auto',
          display: 'block',
        }}
      />

      {/* Conteúdo sobre o cabeçalho */}
      <div
        className="cabecalho-conteudo"
        style={{
          position: 'absolute',
          left: '11%',
          top: '70%',
          transform: 'translateY(-50%)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          width: '40%',
          maxWidth: '450px',
        }}
      >
        {/* Imagem Clube */}


        {/* Botão */}
        <button
          className="botao-clube"
          style={{
            background: 'linear-gradient(90deg, #5b3aa8, #7047b8)',
            color: '#fff',
            border: 'none',
            borderRadius: '15px',
            padding: '10px 25px',
            marginLeft: 'clamp(0px, 2vw, 25px)',
            fontSize: 'clamp(11px, 1.3vw, 16px)',
            fontWeight: 'bold',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
          }}
          onClick={() => setOpenModalSobreClube(true)}
        >
          Saiba mais sobre o clube
        </button>
      </div>
    </div>
  </Grid>
</Grid>

          {/* ================== ESTRUTURA ==================== */}

          <Grid container item lg={12} sm={12} xs={12}
            justify="center"
            alignItems="center"
            style={{
              marginTop: '-40px',
              position: 'relative',
              zIndex: 10,
            }}
          >
            <div
              style={{
                width: 'min(90%, 1095px)',
                maxWidth: '1095px',
                margin: '0 auto',

                padding: '30px',
                //boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
                boxSizing: 'border-box',
              }}
            >
              <Grid container justify="center"
                style={{
                  width: '100%',
                  margin: 0,
                }}
              >
                <Grid
                  item
                  lg={12}
                  sm={12}
                  xs={12}
                  style={{
                    width: '100%',
                    padding: 0,
                  }}
                >

                    {/* -----------ETAPA 1 --------------- */}
                    <Grid container >
                      {/* ----------- header --------------- */}
                      <Grid container
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Grid
                          item
                          xs={12}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <div
                            className="section-title-wrapper-header"
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <h2
                              className="section-title-text-header"
                              style={{
                                textAlign: "center",
                                margin: 0,
                              }}
                            >
                              TRÊS AMIGOS, UMA MISSÃO DE FÉ
                            </h2>
                          </div>




                        </Grid>
                        <Grid
                          item
                          xs={12}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "80%",
                          }}
                        >
                      <span className="seguranca-text">
                Conheça Tino, Aninha e Vovô Vox, amigos especiais que vão acompanhar cada criança em uma linda jornada de fé, amor e amizade com o Pai Eterno:
                </span></Grid>

                      </Grid>



                      {/* ----------- PERSONAGENS --------------- */}
                      <Grid container style={{ paddingTop: 40 }} >
                      <Grid container className="section-title-grid">
  <div className="clube-cards-container">

    {/* ================= TINO ================= */}
    <div className="clube-card clube-card-tino">
      <div className="clube-card-image">
        <img src={'https://crm-clickdobem.s3.sa-east-1.amazonaws.com/AFIPE/Tino.png'} alt="Tino" />
      </div>

      <div className="clube-card-content">
        <h3>Tino</h3>

        <div className="clube-card-line" />
        <p>
        Curioso, inteligente e cheio de perguntas sobre a fé, Tino adora descobrir coisas novas. Ele mostra que aprender sobre Deus pode ser uma grande aventura!
        </p>
      </div>
      <span className="section-heart-tino">
                              <svg
                                viewBox="0 0 100 90"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                              >
                                <path
                                  d="M50 82 C46 78, 12 57, 8 34 C5 18, 15 7, 29 5 C39 4, 47 9, 50 18 C53 9, 61 4, 71 5 C85 7, 95 18, 92 34 C88 57, 54 78, 50 82 Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
    </div>


    {/* ================= ANINHA ================= */}
    <div className="clube-card clube-card-aninha">
      <div className="clube-card-image">
        <img src={'https://crm-clickdobem.s3.sa-east-1.amazonaws.com/AFIPE/Ana.png'} alt="Aninha" />
      </div>

      <div className="clube-card-content">
        <h3>Aninha</h3>
        <div className="clube-card-line" />
        <p>
          Carinhosa, alegre e apaixonada pela
          natureza e pelos animais. Aninha ensina
          que a fé também está nos pequenos gestos
          de amor e cuidado com o próximo.
        </p>
      </div>
      <span className="section-heart-aninha">
                              <svg
                                viewBox="0 0 100 90"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                              >
                                <path
                                  d="M50 82 C46 78, 12 57, 8 34 C5 18, 15 7, 29 5 C39 4, 47 9, 50 18 C53 9, 61 4, 71 5 C85 7, 95 18, 92 34 C88 57, 54 78, 50 82 Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>

    </div>


    {/* ================= VOVÔ VOX ================= */}
    <div className="clube-card clube-card-vovo">
      <div className="clube-card-image clube-card-image-vovo">
        <img src={'https://crm-clickdobem.s3.sa-east-1.amazonaws.com/AFIPE/Vovo.png'} alt="Vovô Vox" />
      </div>

      <div className="clube-card-content">
        <h3>Vovô Vox</h3>
        <div className="clube-card-line" />
        <p>
          Sábio, acolhedor e cheio de histórias
          encantadoras. Vovô Vox acompanha as
          crianças com muito carinho, ajudando
          os pequenos a conhecerem mais sobre o
          Evangelho e a devoção ao Divino Pai Eterno.
        </p>
      </div>

      <span className="section-heart-vovo">
                              <svg
                                viewBox="0 0 100 90"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                              >
                                <path
                                  d="M50 82 C46 78, 12 57, 8 34 C5 18, 15 7, 29 5 C39 4, 47 9, 50 18 C53 9, 61 4, 71 5 C85 7, 95 18, 92 34 C88 57, 54 78, 50 82 Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>

    </div>

  </div>
</Grid>


                      </Grid>

                      {/* ----------- BOTÃO CONTINUAR --------------- */}
                      <Grid  container item lg={12} sm={12} xs={12} justify="center" style={{marginTop: 49}}>
                      <div className="mission-banner">

<div className="mission-content">

  <div className="mission-title">
    <span>✦</span>

    <strong>
      Pequenas atitudes, grandes mudanças!
    </strong>

    <span>✦</span>
  </div>

  <ButtonComponent
                            color="secondary"
                            style={{
                              width: '100%',
  maxWidth: '340px',
  minHeight: '45px',
  height: 'auto',
  minWidth: 0,
  borderRadius: '22px',
  background: 'linear-gradient(90deg, #f65d91, #ed6393)',
  border: 'none',
  color: '#fff',
  fontSize: 'clamp(14px, 1.5vw, 18px)',
  fontWeight: 400,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '10px',
  padding: '10px 20px',
  boxShadow: 'none',
  boxSizing: 'border-box',
                            }}
                            onClick={() => { window.location.href = '/cadastro-mirim';}}

                          >
                            <span>Quero fazer parte dessa missão!</span>


                          </ButtonComponent>

</div>

</div>
                        <Form
                          //form={formPessoaRef}
                          scrollToFirstError={true}
                          //onFinish={onSubmitTeste}
                        >

                        </Form>
                      </Grid>


                      {/* ----------- BOTÃO VOLTAR PÁGINA ClubePaiEterno --------------- */}
                      <Grid item lg={12} sm={12} xs={12} style={{paddingTop: 10}} >
                        <Button2
                          color='default'
                          onClick={() => { window.location.href = '/';}}
                          style={{color: '#000', fontSize: '16px', backgroundColor: 'transparent'}}
                        >
                          Voltar
                        </Button2>
                      </Grid>
                    </Grid>






                </Grid>
              </Grid>


            </div>
          </Grid>

          {/* --------------------------- RODAPÉ 1 ----------------------------- */}

          <Grid container item xs={12} style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0 12px', boxSizing: 'border-box', marginTop: 20, backgroundColor: '#6DBAE7' }} >
            <a href="https://wa.me/556235069800" target="_blank" rel="noopener noreferrer"
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexWrap: 'wrap',
                textAlign: 'center',
                gap: '5px',
                textDecoration: 'none',
                color: '#333',
              }}
            >
              <PhoneOutlined style={{ fontSize: '20px', color: '#FFF', }} />
              <span style={{ fontSize: '16px', fontWeight: 600, textAlign: 'center', color: '#FFF' }} >
                Central de Relacionamento:
              </span>
              <span style={{ fontSize: '16px', fontWeight: 600, textDecoration: 'underline', textAlign: 'center', color:'#FFF'}} >
                (62) 3506-9800
              </span>
            </a>
          </Grid>

          {/* --------------------------- RODAPÉ 2 ----------------------------- */}



          {/* --------------------------- RODAPÉ 3 ----------------------------- */}

          <Grid item lg={12} sm={12} xs={12} style={{paddingTop: 0}}>
            <Grid container alignItems="center" justify="center"
              style={{backgroundColor: '#6DBAE7', paddingTop: 10, paddingBottom: 10}}
            >
              <Grid container item lg={8} sm={8} xs={12} alignItems="center" justify="center" >
                <TitlePage style={{fontSize: 14, color:'#FFF'}}>Desenvolvido por  </TitlePage>
                <img src={'https://amex-arquivos.s3.sa-east-1.amazonaws.com/sociallis-logoPng.png'} style={{paddingLeft:10, width: 140 }} />
              </Grid>
            </Grid>
          </Grid>
        </div>

      </Grid>


    </>

  );
};

export default ClubePaiEterno;
